// Known client (business/marketplace) values for the Spam Rules / Flows
// selectors — distinct from channel (technical transport, see channels.js):
// a future Amazon-via-eBay integration could still be channel 'ebay' while
// its client is 'Amazon'.
//
// This MUST match server/src/companies.js's CLIENTS export. Duplicated here
// only because `ui` has no dependency on the server workspace package.
//
// server/test/client-list-sync.test.js asserts this file and the registry
// agree, so the duplication cannot drift silently.
export const KNOWN_CLIENTS = ['eBay', 'Amazon', 'Website', 'Internal', 'Walmart']
